import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { featuredComics, latestUpdates } from '@/mocks/zh/comics';

const chapters = [
  { num: 189, title: '最终决战（三）', date: '2026-07-02', isNew: true },
  { num: 188, title: '最终决战（二）', date: '2026-06-25', isNew: false },
  { num: 187, title: '最终决战（一）', date: '2026-06-18', isNew: false },
  { num: 186, title: '王的归来', date: '2026-06-11', isNew: false },
  { num: 185, title: '觉醒', date: '2026-06-04', isNew: false },
  { num: 184, title: '最后的试炼', date: '2026-05-28', isNew: false },
  { num: 183, title: '暗影军团', date: '2026-05-21', isNew: false },
  { num: 182, title: '不可战胜的敌人', date: '2026-05-14', isNew: false },
  { num: 181, title: '新力量', date: '2026-05-07', isNew: false },
  { num: 180, title: '突破极限', date: '2026-04-30', isNew: false },
  { num: 179, title: '守护', date: '2026-04-23', isNew: false },
  { num: 178, title: '并肩作战', date: '2026-04-16', isNew: false },
  { num: 177, title: '援军', date: '2026-04-09', isNew: false },
  { num: 176, title: '绝望中的希望', date: '2026-04-02', isNew: false },
  { num: 175, title: '突袭', date: '2026-03-26', isNew: false },
];

const comments = [
  {
    id: 1,
    user: '漫迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20illustration%20of%20a%20young%20male%20character%20with%20dark%20hair%20friendly%20expression%20minimalist%20style%20clean%20background&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    content: '这一话真的太燃了！成肖宇的实力已经完全超越了所有人的想象，暗影军团真的太帅了！每次更新都等得我心痒痒～',
    date: '2026-07-02',
    likes: 128,
  },
  {
    id: 2,
    user: '追漫少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20illustration%20of%20a%20young%20female%20character%20with%20pink%20hair%20cute%20expression%20minimalist%20style%20clean%20background&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    content: '从第一话追到现在，见证了主角从最弱到最强的蜕变，画风也越来越精致了。韩漫的天花板级别作品！',
    date: '2026-07-01',
    likes: 96,
  },
  {
    id: 3,
    user: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20illustration%20of%20a%20male%20character%20with%20glasses%20calm%20expression%20minimalist%20style%20clean%20background&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    content: '剧情节奏控制得很好，不会太快也不会拖沓。每次战斗场景的分镜都让人热血沸腾，强烈推荐给所有人！',
    date: '2026-06-30',
    likes: 74,
  },
  {
    id: 4,
    user: '韩漫控',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20illustration%20of%20a%20female%20character%20with%20short%20hair%20cool%20expression%20minimalist%20style%20clean%20background&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    content: '这部是我入坑韩漫的第一部作品，从此就停不下来了。作者对角色成长的刻画太到位了，每个配角都有自己的故事。',
    date: '2026-06-29',
    likes: 55,
  },
  {
    id: 5,
    user: '漫画评论家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20avatar%20illustration%20of%20a%20male%20character%20with%20silver%20hair%20wise%20expression%20minimalist%20style%20clean%20background&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    content: '客观来说，这部作品的世界观构建、角色塑造和战斗系统设计都是顶级水平。尤其是"系统"这个设定，给升级流带来了全新的体验。',
    date: '2026-06-28',
    likes: 42,
  },
];

const allComics = [...featuredComics, ...latestUpdates].filter(
  (v, i, a) => a.findIndex((t) => t.id === v.id) === i
);

const articleSchema = (comic: typeof featuredComics[0]) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: `${comic.title} - 韩漫免费网站`,
  description: comic.description,
  author: { '@type': 'Person', name: comic.author.split(' / ')[0] },
  datePublished: '2023-01-01',
  dateModified: comic.updateTime,
  publisher: {
    '@type': 'Organization',
    name: '韩漫免费网站',
    url: 'http://lczydmb.com/',
  },
});

const breadcrumbSchemaData = (comic: typeof featuredComics[0]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'http://lczydmb.com/' },
    { '@type': 'ListItem', position: 2, name: comic.category, item: 'http://lczydmb.com/category/all' },
    { '@type': 'ListItem', position: 3, name: comic.title },
  ],
});

export default function ArticlePage() {
  const comic = featuredComics[0];
  const [activeTab, setActiveTab] = useState<'chapters' | 'comments'>('chapters');
  const relatedComics = allComics.filter((c) => c.id !== comic.id).slice(0, 4);

  return (
    <>
      <SEOHead
        title={`${comic.title}_${comic.altTitle}_韩漫在线阅读-韩漫网站`}
        description={comic.description}
        keywords={`${comic.title},${comic.altTitle},韩漫,韩国漫画,${comic.category},在线免费阅读`}
        canonicalUrl={`http://lczydmb.com/article/${comic.id}`}
        ogType="article"
        ogImage={comic.cover}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema(comic)) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchemaData(comic)) }} />

      <Navbar />

      <main className="min-h-screen pt-16">
        <section className="relative py-12 md:py-16 px-4 md:px-6 overflow-hidden">
          <img
            src={comic.cover}
            alt={comic.title}
            className="absolute inset-0 w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/80" />

          <div className="relative z-10 max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: comic.category, path: '/category/all' },
                { name: comic.title },
              ]}
            />

            <div className="flex flex-col md:flex-row gap-8 mt-8">
              <div className="md:w-[300px] flex-shrink-0">
                <div className="relative overflow-hidden rounded-2xl aspect-[3/4]">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫免费网站`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  {comic.tags.map((tag) => (
                    <span key={tag} className="bg-background-50/20 backdrop-blur-sm text-background-50 text-xs px-3 py-1 rounded-full font-label whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>

                <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-2">{comic.title}</h1>
                <p className="text-background-100/60 text-sm mb-4">{comic.altTitle}</p>

                <div className="flex items-center gap-4 flex-wrap mb-6">
                  <span className="text-sm text-background-100/80">
                    <i className="ri-user-line mr-1" />{comic.author}
                  </span>
                  <span className="text-sm text-background-100/80">
                    <i className="ri-star-fill text-accent-400 mr-1" />{comic.rating}
                  </span>
                  <span className="text-sm text-background-100/80">
                    <i className="ri-eye-line mr-1" />{comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
                  </span>
                  <span className={`text-sm px-2 py-0.5 rounded-full font-label whitespace-nowrap ${comic.status === '连载中' ? 'bg-accent-500/20 text-accent-400' : 'bg-foreground-500/20 text-foreground-400'}`}>
                    {comic.status}
                  </span>
                </div>

                <p className="text-sm text-background-100/70 leading-relaxed max-w-2xl mb-6">
                  {comic.description}
                </p>

                <div className="flex items-center gap-3 flex-wrap">
                  <Link
                    to="/category/all"
                    className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-colors duration-200 inline-flex items-center"
                  >
                    <i className="ri-play-circle-line mr-2 text-base" />
                    开始阅读
                  </Link>
                  <Link
                    to="/category/all"
                    className="border border-background-50/40 hover:border-background-50 text-background-50 px-6 py-3 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200"
                  >
                    最新话：{chapters[0].title}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-1 mb-8 bg-background-100 rounded-full p-1 w-fit">
              <button
                onClick={() => setActiveTab('chapters')}
                className={`px-6 py-2 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  activeTab === 'chapters' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                章节列表
              </button>
              <button
                onClick={() => setActiveTab('comments')}
                className={`px-6 py-2 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  activeTab === 'comments' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                读者评论
              </button>
            </div>

            {activeTab === 'chapters' && (
              <div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {chapters.map((ch) => (
                    <Link
                      key={ch.num}
                      to="/category/all"
                      className="group flex items-center justify-between px-5 py-3.5 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <span className="text-sm font-label font-semibold text-foreground-800 flex-shrink-0">
                          第{ch.num}话
                        </span>
                        <span className="text-sm text-foreground-600 truncate group-hover:text-primary-500 transition-colors duration-200">
                          {ch.title}
                        </span>
                        {ch.isNew && (
                          <span className="bg-primary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-label whitespace-nowrap flex-shrink-0">
                            NEW
                          </span>
                        )}
                      </div>
                      <span className="text-xs text-foreground-400 flex-shrink-0 ml-3">{ch.date}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'comments' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {comments.map((comment) => (
                  <div
                    key={comment.id}
                    className="p-5 rounded-xl bg-background-100 flex gap-4"
                  >
                    <img
                      src={comment.avatar}
                      alt={comment.user}
                      className="w-10 h-10 rounded-full flex-shrink-0 object-cover"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-label font-semibold text-foreground-800">{comment.user}</span>
                        <span className="text-xs text-foreground-400">{comment.date}</span>
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                      <div className="flex items-center gap-4 mt-3">
                        <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                          <i className="ri-thumb-up-line" /> {comment.likes}
                        </button>
                        <button className="text-xs text-foreground-400 hover:text-foreground-700 transition-colors duration-200 cursor-pointer">
                          <i className="ri-chat-1-line" /> 回复
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
              相关<strong className="text-primary-500">推荐</strong>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {relatedComics.map((c) => (
                <Link
                  key={c.id}
                  to="/category/all"
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                    <img
                      src={c.cover}
                      alt={c.title}
                      title={`${c.title} - 韩漫免费网站`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
                    {c.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{c.category}</span>
                    <span className="text-xs text-accent-500">★ {c.rating}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20Korean%20manhwa%20style%20wide%20illustration%20of%20a%20reading%20nook%20with%20soft%20warm%20lighting%20books%20and%20a%20digital%20tablet%20displaying%20colorful%20comic%20pages%20inviting%20comfortable%20atmosphere%20gentle%20golden%20and%20peach%20tones&width=1600&height=600&seq=cta-article-bottom&orientation=landscape"
            alt="继续阅读更多韩漫"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/70" />

          <div className="relative z-10 text-center max-w-xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              还想看<strong className="text-accent-400">更多</strong>？
            </h2>
            <p className="text-sm text-background-100/80 mb-6">
              5000+部韩漫等你来探索，发现下一部让你沉迷的作品
            </p>
            <Link
              to="/category/all"
              className="group inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-background-50 px-8 py-3.5 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all duration-200"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className="ri-compass-3-line text-xs" />
              </span>
              探索更多
              <i className="ri-arrow-right-up-line ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}